/**
 * TableHeader Component
 */

import * as React from 'react';

import { Span } from '../Label';

interface ITableHeaderProps {
  label: string;
}

export function TableHeader(props: ITableHeaderProps) {
  return (
    <Span size="small" block><strong>{props.label}</strong></Span>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/text/TableHeader/index.tsx